import { render, staticRenderFns } from "./ProceduresForm.vue?vue&type=template&id=6eaee9c3"
import script from "./ProceduresForm.vue?vue&type=script&lang=js"
export * from "./ProceduresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports